import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { AsyncOutputJob, IOutputJob } from '@elderbyte/ngx-imprimo'
import { ElderToastService, RestClientPaged } from '@elderbyte/ngx-starter'
import { Observable, throwError } from 'rxjs'
import { catchError, map } from 'rxjs/operators'
import { environment } from '../../../../environments/environment'
import { NewReportJob } from './report-job'

@Injectable({
  providedIn: 'root',
})
export class ReportJobService extends RestClientPaged<IOutputJob, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/report-jobs', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public createAsync(newJob: NewReportJob): Observable<AsyncOutputJob> {
    return super.create(newJob).pipe(
      map((job) => this.asAsyncJob(job)),
      catchError((err) => {
        this.toastService.error('Failed to create ReportJob! ', err)
        // return of(AsyncOutputJob.creationFailed(err));
        return throwError(() => err)
      })
    )
  }

  public findJobByIdAsAsync(jobId: string): Observable<AsyncOutputJob> {
    return this.findById(jobId).pipe(map((job) => this.asAsyncJob(job)))
  }

  public asAsyncJob(job: IOutputJob): AsyncOutputJob {
    return AsyncOutputJob.of(job, this)
  }
}
